import { Box, Stack, Grid } from '@mui/material';

import StripeCard from '@/components/StripeCard';
import SubscriptionCard from '@/components/SubscriptionCard';

import { IUserData } from '../types';

interface Props {
  userData: IUserData;
  onConnect: () => Promise<string>;
  onResumeSetup: () => Promise<string>;
  canConnectStripe: boolean;
  canUseStripeServiceFees: boolean;
  onSubscriptionError?: (error: string) => void;
}

export function GeneralView({
  userData,
  onConnect,
  onResumeSetup,
  canConnectStripe,
  canUseStripeServiceFees,
  onSubscriptionError,
}: Props) {
  return (
    <Stack spacing={5}>
      {canConnectStripe && canUseStripeServiceFees ? (
        <>
          {/* Side-by-side cards for accounts with both tenant billing and service fees */}
          <Grid container spacing={2} sx={{ maxWidth: 800 }}>
            <Grid item xs={12} sm={6}>
              {/* Tenant billing (existing functionality) */}
              <Box sx={{ height: 450, '& > *': { height: '100%' } }}>
                <StripeCard
                  connectAccount={onConnect}
                  accountLink={onResumeSetup}
                  stripeUserID={userData.connectedAccountId}
                  setUpFinished={userData.connectedAccountDetailsSubmitted}
                  showBillingContactWarning={
                    !!(userData.connectedAccountId && userData.connectedAccountDetailsSubmitted)
                  }
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              {/* SimpleSUB service fee */}
              <Box sx={{ height: 450, '& > *': { height: '100%' } }}>
                <SubscriptionCard onError={onSubscriptionError} />
              </Box>
            </Grid>
          </Grid>
        </>
      ) : canConnectStripe ? (
        <>
          {/* Tenant billing only (service fees handled externally) */}
          <Grid container spacing={2} sx={{ maxWidth: 400 }}>
            <Grid item xs={12}>
              <Box sx={{ height: 450, '& > *': { height: '100%' } }}>
                <StripeCard
                  connectAccount={onConnect}
                  accountLink={onResumeSetup}
                  stripeUserID={userData.connectedAccountId}
                  setUpFinished={userData.connectedAccountDetailsSubmitted}
                  showBillingContactWarning={
                    !!(userData.connectedAccountId && userData.connectedAccountDetailsSubmitted)
                  }
                />
              </Box>
            </Grid>
          </Grid>
        </>
      ) : canUseStripeServiceFees ? (
        <>
          {/* Service fees only (no tenant billing) */}
          <Grid container spacing={2} sx={{ maxWidth: 400 }}>
            <Grid item xs={12}>
              <Box sx={{ height: 450, '& > *': { height: '100%' } }}>
                <SubscriptionCard onError={onSubscriptionError} />
              </Box>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          {/* No billing features enabled - show message or nothing */}
          <Box>{/* Could show a message about billing being handled externally */}</Box>
        </>
      )}
    </Stack>
  );
}
